import findStep from "../findStep";
import useBotControlStore from "../../../../storeModules/useBotControlStore";
import useConsorcioStore from "../../../../storeModules/useConsorcioStore";
import {
  tagMetodoPagamento,
  tagMetodoPagamentoAlterado,
  tagComprarNovaCota,
} from "../../../../utils/sendTag";
import {
  addPaymentInfoTag,
  beginCheckoutTag,
} from "../../../../utils/sendTag/index";
import { resetStoreComprarNovaCota } from "../../../../storeModules/resetStoreComprarNovaCota";
import useUserStore from "../../../../storeModules/useUserStore";
import { metodosPagamentoNames } from "../../../../utils/constants";
import useInsuranceStore from "../../../../storeModules/useInsuranceStore";
import usePaymentStore from "../../../../storeModules/usePaymentStore";
import addMoneyMask from "../../../../utils/addMoneyMask";
import { startNewConversacaoSession } from "../../../../api/requestsFunctions/conversacao";

const getPaymentMessage = () => {
  const { couponFirstParcel, insuranceFirstParcel, firstParcel } =
    usePaymentStore.getState();

  const { isInsuranceHired, valorPremio } = useInsuranceStore.getState();

  const { valorDescontado, valorTotal } = useUserStore.getState().cupomData;

  if (valorDescontado && !isInsuranceHired) {
    return `Como prefere <b>pagar</b> a <b>1ª parcela</b> no valor de <strike>${addMoneyMask(valorTotal)}</strike> ${addMoneyMask(couponFirstParcel)}?`;
  } else if (!valorDescontado && isInsuranceHired) {
    return `Como prefere <b>pagar</b> a <b>1ª parcela com o seguro prestamista</b> no valor de <b>${addMoneyMask(insuranceFirstParcel)}</b>?`;
  } else if (valorDescontado && isInsuranceHired) {
    return `Como prefere <b>pagar</b> a <b>1ª parcela com o seguro prestamista</b> no valor de <b>${addMoneyMask(couponFirstParcel + valorPremio)}</b>?`;
  } else {
    return `Como prefere <b>pagar</b> a <b>1ª parcela</b> no valor de <b>${addMoneyMask(firstParcel)}</b>?`;
  }
};

const pagamentoSteps = [
  {
    name: "inicio_pagamento",
    sender: "bot",
    text: "Para <b>concluir a contratação e garantir a sua oferta, efetue o pagamento da primeira parcela</b> e participe do próximo sorteio. 🥳",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("primeira_parcela").index,
      });
    },
  },
  {
    name: "primeira_parcela",
    sender: "bot",
    text: () => {
      return getPaymentMessage();
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("proposta_gerada").index,
      });
    },
  },
  {
    name: "proposta_gerada",
    sender: "bot",
    text: "Escolha uma opção:",
    action: () => {
      beginCheckoutTag();
    },
    options: () => {
      return (
        useConsorcioStore.getState().fetchedProposta
          ?.formasPagamentoDisponiveis ?? []
      )
        .filter((code) => [5, 0, 1].includes(code))
        .map((code) => {
          const options = {
            5: {
              text: "PIX",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "pix",
                });
                tagMetodoPagamento(metodosPagamentoNames.PIX);
                addPaymentInfoTag();
                useBotControlStore.setState({
                  currentStep: findStep("registro_pix").index,
                });
              },
            },
            0: {
              text: "CARTÃO (3X SEM JUROS)",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "credito",
                });
                tagMetodoPagamento(metodosPagamentoNames.CARTÃO);
                addPaymentInfoTag();
                useBotControlStore.setState({
                  currentStep: findStep("mensagem_seguranca_cartao").index,
                });
              },
            },
            1: {
              text: "BOLETO",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "boleto",
                });
                tagMetodoPagamento(metodosPagamentoNames.BOLETO);
                addPaymentInfoTag();
                useBotControlStore.setState({
                  currentStep: findStep("gerando_boleto").index,
                });
              },
            },
          };
          return options[code];
        });
    },
  },
  {
    name: "compra_finalizada",
    sender: "bot",
    text: "Você quer <b>comprar outra</b> cota?",
    options: [
      {
        text: "SIM",
        action: async () => {
          await startNewConversacaoSession();
          useBotControlStore.setState({
            currentStep: findStep("pergunta_mesmo_credito").index,
          });
        },
      },
      {
        text: "NÃO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("inicio_pesquisa").index,
          });
        },
      },
    ],
  },
  {
    name: "continuar_pagamento",
    sender: "bot",
    text: "Escolha uma das opções:",
    options: [
      {
        text: "CONTINUAR",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("continuar_pagamento").index,
          });
        },
      },
    ],
  },
  {
    name: "pergunta_mesmo_credito",
    sender: "bot",
    text: "Será com o mesmo valor de crédito e parcelas?",
    options: [
      {
        text: "NÃO",
        action: () => {
          tagComprarNovaCota(true, false);

          resetStoreComprarNovaCota();

          useBotControlStore.setState({
            currentStep: findStep("carrega_categorias").index,
          });
        },
      },
      {
        text: "SIM",
        action: () => {
          tagComprarNovaCota(true, true);

          useBotControlStore.setState({
            currentStep: findStep("revisao_dados_pessoais").index,
          });
        },
      },
    ],
  },
  {
    name: "alterar_forma_pagamento",
    sender: "bot",
    text: "Escolha uma opção:",
    action: () => {
      tagMetodoPagamentoAlterado();
    },
    options: () => {
      return (
        useConsorcioStore.getState().fetchedProposta
          ?.formasPagamentoDisponiveis ?? []
      )
        .filter((code) => [5, 0, 1].includes(code))
        .map((code) => {
          const options = {
            5: {
              text: "PIX",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "pix",
                });
                tagMetodoPagamento(metodosPagamentoNames.PIX);
                addPaymentInfoTag();

                useBotControlStore.setState({
                  currentStep: findStep("registro_pix").index,
                });
              },
            },
            0: {
              text: "CARTÃO (3X SEM JUROS)",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "credito",
                });
                tagMetodoPagamento(metodosPagamentoNames.CARTÃO);
                addPaymentInfoTag();

                useBotControlStore.setState({
                  currentStep: findStep("mensagem_seguranca_cartao").index,
                });
              },
            },
            1: {
              text: "BOLETO",
              action: () => {
                const paymentState = usePaymentStore.getState();
                usePaymentStore.setState({
                  ...paymentState,
                  paymentMethodSelected: "boleto",
                });
                tagMetodoPagamento(metodosPagamentoNames.BOLETO);
                addPaymentInfoTag();

                useBotControlStore.setState({
                  currentStep: findStep("gerando_boleto").index,
                });
              },
            },
          };
          return options[code];
        });
    },
  },
];

export default pagamentoSteps;
